<template>
  <div class="component component--fullscreen" v-if="visable">
    <transition name="overlay">
      <div class="component__overlay" v-if="componentVisible"></div>
    </transition>
    <transition name="reward">
      <div class="component__containter" v-if="componentVisible" ref="containter">
        <div class="reward">
          <button class="reward-close" v-on:click="close()"><i class="material-icons">clear</i></button>
          <div class="reward-header">
            <div class="reward-title">{{ reward.title }}</div>
            <div class="reward-fig">
              <img :src="reward.image">
              <div
                class="reward-status"
                :style="{
                  'background-color': reward.status === 2 || reward.status === 3 ? '#FFFFFF' : `#${point.color}`,
                  'color': reward.status === 2 || reward.status === 3 ? `#${point.color}` : '#FFFFFF',
                }"
              >
                <i class="material-icons" v-if="reward.status === 2 || reward.status === 3">lock_open</i>
                <i class="material-icons" v-else-if="reward.status === 0">lock</i>
              </div>
            </div>
          </div>
          <div class="reward-button">
            <a
              v-if="reward.status === 2" :style="`background-color: #${point.bgColor}; color: #${point.color}`"
              v-on:click="claim"
            >
              {{ $t("points.claim") }}
            </a>
            <span v-else-if="reward.status === 3">
              {{ $t("points.received") }}
            </span>
            <span v-else-if="reward.status === 0">
              {{ $tc("points.toUnlock", reward.require_point, { point: reward.require_point }) }}
            </span>
          </div>
          <div class="reward-body">
            <div class="section-title">{{ $t('reward.content') }}</div>
            <div class="desc" v-html="reward.content" v-linkified></div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import linkify from 'vue-linkify';

export default {
  name: 'Milestone-Detail',
  props: {
    visable: {
      type: Boolean,
      required: true,
    },
    reward: {
      type: Object,
      required: true,
    },
    point: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      componentVisible: false,
    };
  },
  watch: {
    visable(value) {
      this.$nextTick(() => {
        this.componentVisible = value;
      });

      if (value) {
        this.$gtm.trackEvent({
          event: '查看會員資格詳情',
          label: `${this.$root.$store.state.brand.name} - ${this.vip.name}`,
        });
      }
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    claim() {
      this.$emit('claim');
      this.$emit('close');
    },
  },
  directives: {
    linkified: linkify,
  },
};
</script>

<style lang="sass" scoped>
.component--fullscreen
  position: fixed
  top: 0
  right: 0
  bottom: 0
  left: 0
  z-index: 1040

  transition: all .25s ease

.component__overlay
  position: fixed
  top: 0
  right: 0
  bottom: 0
  left: 0
  z-index: 1040
  opacity: .7

  background-image: linear-gradient(0deg, rgba(44,43,43,0.95) 0%, rgba(33,32,32,0.95) 100%)

.component__containter
  position: fixed
  top: 0
  right: 0
  bottom: 0
  left: 0
  z-index: 1050
  padding-top: 50vh
  margin: 0 auto
  overflow: auto
  -webkit-overflow-scrolling: touch

  @media only screen and (min-width : 768px)
    max-width: 500px

.reward
  position: relative
  padding: 12px 16px
  min-height: calc(100vh - 54px)

  border-radius: 16px 16px 0 0

  background-color: white

  &-close
    position: absolute
    top: 12px
    right: 12px
    padding: 8px
    width: 40px
    height: 40px

    border: none
    border-radius: 12px

    background-color: #F1F1F1

    color: #909090

    outline: none

    &:active
      color: #333

  &-title
    font-weight: bold
    font-size: 1rem
    text-align: center
    line-height: 40px

  &-fig
    position: relative
    margin: 8px auto 0
    width: 50%
    max-width: 250px

    text-align: center

    img
      width: 100%
      border-radius: 100%

  &-status
    position: absolute
    top: auto
    right: 0
    bottom: 0
    left: auto
    width: 38px
    height: 38px
    z-index: 120
    display: flex
    justify-conetnet: center
    align-items: center

    border-radius: 100%

    text-align: center

    .material-icons
      flex-grow: 1

    &::after
      position: absolute
      top: 0
      right: 0
      bottom: 0
      left: 0
      z-index: 2

      border-radius: 100%
      border: .5px solid rgba(0, 0, 0, 0.1)

      content: ''

  &-button
    margin: 16px 0
    text-align: center

    a,
    span
      padding: 8px 16px
      display: inline-block

      border-radius: 10px
      font-size: 0.75rem
      color: #8E8E8E
      font-weight: bold

.section-title
  margin: 24px 8px 8px

  color: #686868
  font-size: 0.875rem
  font-weight: bold
  letter-spacing: 2px
  text-transform: uppercase

.desc
  margin: 8px 0 24px
  white-space: pre-wrap

  font-size: 0.875rem
  line-height: 1.6

  ::v-deep .linkified
    color: white
    text-decoration: underline

.overlay-enter-active,
.overlay-leave-active
  transition: opacity .25s cubic-bezier(.4, 0, .2, 1)

.overlay-enter,
.overlay-leave-to
  opacity: 0

.reward-enter-active,
.reward-leave-active
  transition: opacity .25s cubic-bezier(.4, 0, .2, 1), transform .15s cubic-bezier(.4, 0, .2, 1)

.reward-enter,
.reward-leave-to
  opacity: 0
  transform: translateY(100%)
</style>
